import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Dictionary } from 'lodash';
import { forkJoin, Observable, observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Company } from '../../../models/company.model';
import { CompanyInformation } from '../../../models/shared-catalog/company-information.models';
import { Theme } from '../../../models/themes/theme.model';
import { UnsubscribeComponent } from '../../../shared-components/components/unsubscribe/unsubscribe.abstract';
import { CompanyService } from '../../../shared-services/services/company.service';
import { ThemeService } from '../../../shared-services/services/theme.service';
import { LockerCancellationCompanyResponse } from '../../models/locker-cancellation-company-response.model';
import { LockerCancellationDialogService } from '../../services/locker-cancellation-dialog.service';

@Component({
    selector: 'app-locker-cancellation-dialog-login-page',
    templateUrl: './locker-cancellation-dialog-login-page.component.html',
    styleUrls: ['./locker-cancellation-dialog-login-page.component.scss'],
    standalone: false
})
export class LockerCancellationDialogLoginPageComponent extends UnsubscribeComponent implements OnInit {

    public lockerCancellationCompanyResponse: LockerCancellationCompanyResponse;
    public theme: Theme;
    public institutions: CompanyInformation[];
    public companyName: string;
    public companyAppName: string;

    public lockerCancellationVerbiageRequest = [];
    public lockerCancellationVerbiageResponse: any;
    public lockerCancellationVerbiageResponseContent: string;
    public lockerCancellationVerbiageReplaced: string;
    public getAll$: Observable<any>;

    constructor(
        public dialogRef: MatDialogRef<LockerCancellationDialogLoginPageComponent>,
        public lockerCancellationDialogService: LockerCancellationDialogService,
        public themeService: ThemeService
    ) {
        super();
    }

    ngOnInit() {
        this.getCompanyCustomMessage();
    }

    public close(): void {
        this.dialogRef.close();
    }

    public getCompanyCustomMessage(): void {
        this.lockerCancellationVerbiageRequest.push('LOCKER_CANCELLATION_VERBIAGE');

        this.getAll$ = forkJoin([
            this.themeService.loadThemeForHost(),
            this.lockerCancellationDialogService.getCompanyHostCustomMessageForLoginPage(this.lockerCancellationVerbiageRequest)
        ]);

        this.getAll$
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(([theme, hostResponse]: [Theme, LockerCancellationCompanyResponse]) => {

                this.lockerCancellationVerbiageResponse = JSON.parse(JSON.stringify(hostResponse));

                this.companyAppName = hostResponse.companyAppName !== undefined ? hostResponse.companyAppName : theme.appName;
                this.companyName = hostResponse.companyName !== undefined ? hostResponse.companyName : theme.titleBar;

                this.lockerCancellationVerbiageResponseContent = this.lockerCancellationVerbiageResponse.Message['LOCKER_CANCELLATION_VERBIAGE'];  // eslint-disable-line max-len

                const newString = this.lockerCancellationVerbiageResponseContent.replace(/<Customer Locker Name>/g, this.companyAppName);  // eslint-disable-line max-len
                this.lockerCancellationVerbiageReplaced = newString.replace(/<Customer Name>/g, this.companyName);

                if (this.companyName === 'FinLocker') {
                   this.lockerCancellationVerbiageReplaced = this.lockerCancellationVerbiageReplaced.replace('FinLocker and FinLocker', 'FinLocker'); // eslint-disable-line max-len
                }
            });
    }
}
